import { render, staticRenderFns } from "./EntrepreneurVerticalName.vue?vue&type=template&id=2478a607&scoped=true&"
import script from "./EntrepreneurVerticalName.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurVerticalName.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurVerticalName.vue?vue&type=style&index=0&id=2478a607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478a607",
  null
  
)

export default component.exports